import * as React from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { bindActionCreators, Dispatch } from "redux";

import * as Actions from "../../actions";
import Firebase, { withFirebase } from "../../Firebase";
import { ILoginState } from "../../models/state";
import * as States from "../../models/state";

import * as ROUTES from "../../constants/routes";

import * as firebase from "firebase";

import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";

import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";

const styles = (theme: Theme) => ({
  formBox: {
    margin: "auto",
    marginTop: "4em",
    maxWidth: "30%"
  }
});

type Props = ReturnType<typeof mapStateToProps> &
  WithStyles<typeof styles> &
  ReturnType<typeof mapDispatchToProps> & {
    firebase: Firebase;
  };

class SignInFormBase extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public render() {
    if (this.props.user !== null) {
      this.props.history.push(ROUTES.LANDING);
    }
    const isInvalid = this.props.password === "" || this.props.email === "";
    const { classes } = this.props;
    return (
      <Paper className={classes.formBox}>
        <h1>Sign In</h1>
        <form onSubmit={this.onSubmit}>
          <div>
            <TextField
              name="email"
              value={this.props.email}
              onChange={this.onChange}
              type="text"
              placeholder="Email Address"
            />
          </div>
          <div>
            <TextField
              name="password"
              value={this.props.password}
              onChange={this.onChange}
              type="password"
              placeholder="Password"
            />
          </div>
          <Button disabled={isInvalid} type="submit">
            Sign In
          </Button>
        </form>
      </Paper>
    );
  }

  private onChange(e: React.ChangeEvent<HTMLInputElement>) {
    switch (e.target.name) {
      case "email":
        this.props.onEmailChange(e.target.value);
        break;
      case "password":
        this.props.onPasswordChange(e.target.value);
        break;
    }
  }

  private onSubmit(e: React.FormEvent) {
    const { email, password } = this.props;
    e.preventDefault();
    this.props.onSubmit(this.props.firebase, email, password);
  }
}

interface IProps extends ILoginState {
  user: firebase.User | null;
  history?: any;
}

const mapStateToProps = (state: States.IApplicationState): IProps => ({
  ...state.login,
  user: state.session.user
});

const mapDispatchToProps = (dispatch: Dispatch<Actions.IAction>) =>
  bindActionCreators(
    {
      onEmailChange: Actions.Auth.EmailChanged,
      onPasswordChange: Actions.Auth.PasswordChanged,
      onSubmit: Actions.Auth.doAuthenticate
    },
    dispatch
  );

const SignInForm = compose(
  withStyles(styles),
  withRouter,
  withFirebase,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SignInFormBase);

const SignInPage = () => (
  <div>
    <SignInForm />
  </div>
);

export default SignInPage;
export { SignInForm };



// WEBPACK FOOTER //
// ./src/components/SignIn/index.tsx